import { Parser } from 'html-to-react';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { LogRocket } from '../../common/lib/logrocket';

type CustomIframeProps = React.IframeHTMLAttributes<HTMLIFrameElement>;

export const CustomIframe = (props: CustomIframeProps) => {
  const srcDoc = props.srcDoc || ``;
  const [contentRef, setContentRef] = useState<HTMLIFrameElement | null>(null);

  // LogRocket cannot record iframe contents (no SDK inside the sandboxed frame),
  // so log the html to the session console instead.
  useEffect(() => {
    if (srcDoc) LogRocket.log(`iframe preview html`, srcDoc);
  }, [srcDoc]);

  // Check if srcDoc is a full html tree
  if (srcDoc.includes(`<html`) || srcDoc.includes(`<body`)) {
    // SrcDoc is a full html tree, so render as basic iframe
    return (
      <iframe { ...props }
        // Separate key from the portal branch so React never reuses the portal's already-navigated
        // iframe node; sandbox flags only apply on navigation, so a reused node can end up blank.
        key={ `doc` }
        sandbox={ `allow-same-origin allow-popups allow-popups-to-escape-sandbox` }
      />
    );
  }

  // SrcDoc isnt a fully formed html tree, so we need to render it inside the iframe using a portal and convert to jsx
  const htmlParser = Parser();

  const convertedHtml = htmlParser.parse(srcDoc);
  // The mount node for the portal is the iframe's body.
  const mountNode = contentRef?.contentWindow?.document?.body;

  return (
    <iframe { ...props }
      key={ `portal` }
      srcDoc={ `` }
      ref={ setContentRef }
    >
      { mountNode && createPortal(convertedHtml, mountNode) }
    </iframe>
  );
};
